module.exports = __webpack_public_path__ + "img/icon_home.214f84e.webp";